module.exports = "hls/videos/700_KMSAT15_2022_Internet_Based_Attacks-SocialMediaShare/video.m3u8"